import type React from "react";

interface Props {
  size?: number;
  color?: string;
}

export function HeadsetIcon(props: Props): React.ReactNode {
  const { size = 20, color = "black", ...rest } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <title>Headset</title>
      <path
        fill={color}
        d="M17.4999 10.353V9.16638C17.4999 7.17726 16.7098 5.2696 15.3032 3.86308C13.8967 2.45656 11.9891 1.66638 9.99994 1.66638C8.01082 1.66638 6.10316 2.45656 4.69664 3.86308C3.29011 5.2696 2.49994 7.17726 2.49994 9.16638V10.353C1.6259 10.7379 0.910606 11.4113 0.47379 12.2606C0.036974 13.1099 -0.0948441 14.0834 0.100403 15.0183C0.29565 15.9531 0.806111 16.7925 1.54633 17.3959C2.28655 17.9994 3.21159 18.3302 4.16661 18.333C4.60863 18.333 5.03256 18.1575 5.34512 17.8449C5.65768 17.5323 5.83327 17.1084 5.83327 16.6664V11.6664C5.83327 11.2244 5.65768 10.8004 5.34512 10.4879C5.03256 10.1753 4.60863 9.99971 4.16661 9.99971V9.16638C4.16661 7.61929 4.78119 6.13555 5.87515 5.04159C6.96911 3.94763 8.45284 3.33305 9.99994 3.33305C11.547 3.33305 13.0308 3.94763 14.1247 5.04159C15.2187 6.13555 15.8333 7.61929 15.8333 9.16638V9.99971C15.3912 9.99971 14.9673 10.1753 14.6548 10.4879C14.3422 10.8004 14.1666 11.2244 14.1666 11.6664V16.6664H11.6666C11.4456 16.6664 11.2336 16.7542 11.0774 16.9105C10.9211 17.0667 10.8333 17.2787 10.8333 17.4997C10.8333 17.7207 10.9211 17.9327 11.0774 18.089C11.2336 18.2453 11.4456 18.333 11.6666 18.333H15.8333C16.7883 18.3302 17.7133 17.9994 18.4535 17.3959C19.1938 16.7925 19.7042 15.9531 19.8995 15.0183C20.0947 14.0834 19.9629 13.1099 19.5261 12.2606C19.0893 11.4113 18.374 10.7379 17.4999 10.353V10.353ZM4.16661 16.6664C3.50356 16.6664 2.86768 16.403 2.39884 15.9341C1.93 15.4653 1.66661 14.8294 1.66661 14.1664C1.66661 13.5033 1.93 12.8675 2.39884 12.3986C2.86768 11.9298 3.50356 11.6664 4.16661 11.6664V16.6664ZM15.8333 16.6664V11.6664C16.4963 11.6664 17.1322 11.9298 17.601 12.3986C18.0699 12.8675 18.3333 13.5033 18.3333 14.1664C18.3333 14.8294 18.0699 15.4653 17.601 15.9341C17.1322 16.403 16.4963 16.6664 15.8333 16.6664Z"
      />
    </svg>
  );
}
